import {useEffect, useState} from "react";
// -
import {QT2GValuesModel, QT2GHasModel} from "./models/QT2GModels";
import RowTRComponent from "../../../components/RowTRComponent";
import {useTranslation} from "react-i18next";
import useCustomTranslation from "core/customTranslation";
import translations from "../../translations";
import {MiniQ2AdvancedValuesModel} from "../../../MQTT/modes/forms/models/MiniQ2AdvancedModels";

const QT2GForm = ({item}) => {
    const {t: _Tf} = useTranslation("forms");
    const {t: _TC} = useCustomTranslation(translations);
    const [values, setValues] = useState({...QT2GValuesModel});
    const [has, setHas] = useState({...QT2GHasModel});
    const styleCenterMiddle = {textAlign: "center", verticalAlign: "middle"};

    useEffect(() => {
        if (item.id) {
            setValues({...item.values});
            setHas({...item.has});
        } else {
            setValues({...QT2GValuesModel});
            setHas({...QT2GHasModel});
        }
    }, [item]);

    return (
        <div className="row">
            <div className="col-12 mb-5">
                <table className="table table-striped mb-5">
                    <thead>
                    <tr>
                        <th>{_Tf("common.name")}</th>
                        <th>{_Tf("common.description")}</th>
                        <th className="text-center">{_Tf("common.parameters")}</th>
                        <th style={{width: "35px", textAlign: "center"}}>{_Tf("common.actives")}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <RowTRComponent
                        fieldName="ntp_server"
                        _TC={_TC}
                        valueIn={values.ntp_server}
                        hasIn={has.has_ntp_server}
                        deactivated={QT2GValuesModel.ntp_server}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    <RowTRComponent
                        fieldName={"tz"}
                        _TC={_TC}
                        valueIn={values.tz}
                        hasIn={has.has_tz}
                        deactivated={QT2GValuesModel.tz}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    <RowTRComponent
                        fieldName={"sync"}
                        _TC={_TC}
                        valueIn={values.sync}
                        hasIn={has.has_sync}
                        deactivated={QT2GValuesModel.sync}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    </tbody>
                </table>
            </div>
        </div>
    )
}
export default QT2GForm